import { ELanguage } from '../models'

export const APP_DEFAULT_LANGUAGE = ELanguage.EN
